import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { getInstallationsWithoutAccessFetchProps } from 'src/Libs/installations/utils'
import { Box } from '@mui/material'
import InstallationSearchField from '../../InstallationSearchField'
import { makeStyles } from 'tss-react/mui'
import { ApiView } from '@e3dc-react/shell/Elements/ApiView'
import { BlankViewImageVariants, BlankView, BlankViewImageSizes } from 'src/Components/blank-view'
import { useTypedSelector } from 'src/State/RootReducer'
import { useFilteredInstallationsNavigation } from '../../../hooks/use-handle-navigation-when-filtered'
import { InstallationWithoutAccessTableColumns, useInstallationWithoutAccessTableColumns } from 'src/Libs/installations/hooks'

const useStyles = makeStyles()(theme => ({
  inputFilter: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 0,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper2,
    borderRadius: theme.shape.borderRadius,
  },
}))

/**
 * Display installations in a table that the user has no access to.
 * shown in the overview section of the installer dashboard.
 */
const InstallationsWithoutAccess: React.FC = () => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()
  const tableColumns = useInstallationWithoutAccessTableColumns()
  const userData = useTypedSelector(state => state.user.userData)
  const { onChange, filterQuery, filterString } = useFilteredInstallationsNavigation('id')
  const installationWithoutAccessFetchProps = getInstallationsWithoutAccessFetchProps(userData?.Firmen_ID, filterQuery)

  return (
    <>
      <Box className={classes.inputFilter}>
        <InstallationSearchField label={t('installation-statement.overviewTable.installationId')} value={filterString} onChange={onChange} />
      </Box>
      <ApiView<InstallationWithoutAccessTableColumns>
        fetchProps={installationWithoutAccessFetchProps}
        tableColumns={tableColumns}
        hasColoredTableColumns
        dataQaPrefix={'tab-installer-dashboard-no-access'}
        onSelectOnlyInList
        bodyElevation={0}
        footerElevation={0}
        headerElevation={0}
        listElevation={0}
        scrollMarginTop={135}
        onlyTable
        blankView={
          <BlankView
            imageVariant={BlankViewImageVariants.Happy}
            imageSize={BlankViewImageSizes.Small}
            title={'companyDashboard.blank-view.no-access.title'}
            explanation={'companyDashboard.blank-view.no-access.explanation'}
          />
        }
      />
    </>
  )
}

export default InstallationsWithoutAccess
